var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"468c61db7d300f2aa3fcade5c8af73cdbd1bd989"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cloudbase-dapp@delta-labs"]={id:"468c61db7d300f2aa3fcade5c8af73cdbd1bd989"};
      